var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon } from "../../UI";
import { Translate } from "../../I18N";
import api from "../../utils/api";

class Captcha extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    const { refresh } = this.props;

    refresh(this.refresh.bind(this));
    this.state = { svg: '', id: '', remoteUnreachable: false };
  }

  componentDidMount() {
    this.refresh();
  }

  onChange(e) {
    const { onChange } = this.props;
    onChange({ text: e.target.value, id: this.state.id });
  }

  async refresh() {
    const { remote } = this.props;
    const url = remote ? 'remotecaptcha' : 'captcha';
    try {
      const response = await api.get(url);
      this.setState(response.json);
    } catch (ex) {
      if (remote) {
        this.setState({ remoteUnreachable: true });
      }
    }
  }

  render() {
    const { value } = this.props;
    const { svg, remoteUnreachable } = this.state;

    if (!remoteUnreachable) {
      return (/*#__PURE__*/
        _jsx("div", { className: "captcha" }, void 0, /*#__PURE__*/
        _jsx("div", { dangerouslySetInnerHTML: { __html: svg } }), /*#__PURE__*/
        _jsx("input", { className: "form-control", onChange: this.onChange, value: value.text })
        ));

    }
    return (/*#__PURE__*/
      _jsx("div", { className: "alert-danger" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "info-circle" }), "\xA0", /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Remote Server Unreachable"), "."
      ));

  }
}

Captcha.defaultProps = {
  value: { text: '', id: '' },
  refresh: () => {},
  remote: false
};








export default Captcha;